import choosePersonPage from './views/choosePerson.html'

class checkStreamsBranchEditCtrl {
    constructor($scope, $uibModal, $location, logger, httpRequest, $state) {
        $scope.dictData = {}
        $scope.dictData.approve_type = [
            { enumTypeCode: null, enumName: '或签', enumCode: '1' },
            { enumTypeCode: null, enumName: '会签', enumCode: '2' },
        ]
        $scope.dictData.inform_type = [
            { enumTypeCode: null, enumName: '邮件通知', enumCode: 'email' },
            { enumTypeCode: null, enumName: '系统消息', enumCode: 'message' },
        ]
        $scope.dictData.compare_type = [
            { enumTypeCode: null, enumName: '介于两个值之间', enumCode: '9' },
            { enumTypeCode: null, enumName: '或', enumCode: '8' },
            { enumTypeCode: null, enumName: '>', enumCode: '1' },
            { enumTypeCode: null, enumName: '<', enumCode: '2' },
            { enumTypeCode: null, enumName: '=', enumCode: '3' },
            { enumTypeCode: null, enumName: '>=', enumCode: '4' },
            { enumTypeCode: null, enumName: '<=', enumCode: '5' },
            { enumTypeCode: null, enumName: '!=', enumCode: '6' },
            { enumTypeCode: null, enumName: 'equal', enumCode: '7' },
        ]
        $scope.dictData.compare_type_money = [
            { enumTypeCode: null, enumName: '介于两个值之间', enumCode: '9' },
            { enumTypeCode: null, enumName: '>', enumCode: '1' },
            { enumTypeCode: null, enumName: '<', enumCode: '2' },
            { enumTypeCode: null, enumName: '=', enumCode: '3' },
            { enumTypeCode: null, enumName: '>=', enumCode: '4' },
            { enumTypeCode: null, enumName: '<=', enumCode: '5' },
            { enumTypeCode: null, enumName: '!=', enumCode: '6' },
        ]
        const typecodeArr = '["inv_type","invoice_nature","zsxm_dm"]'
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
        const { approveCode } = $state.params
        const isPnumReg = /^[\d]{1,15}$/
        const { branchId } = $state.params
        // 初始化表单数据
        $scope.param = {
            approveCode,
            branchId: '',
            noticeType: '',
            priority: '',
            ruleList: [{
                compareType: '8',
                fieldCode: 'invoice_type',
                refObjectCode: 'invoice_type',
                refValue: '',
                remark: '',
                ruleId: '',
                rulesetId: '',
                state: 1,
            },
            {
                compareType: '8',
                fieldCode: 'invoice_nature',
                refObjectCode: 'invoice_nature',
                refValue: '',
                remark: '',
                ruleId: '',
                rulesetId: '',
                state: 1,
            },
            {
                compareType: '9',
                fieldCode: 'invoice_money',
                refObjectCode: 'invoice_money',
                refValue: '',
                refValue1: '',
                refValue2: '',
                remark: '',
                ruleId: '',
                rulesetId: '',
                state: 1,
            }, {
                compareType: '8',
                fieldCode: 'zsxm_dm',
                refObjectCode: 'zsxm_dm',
                refValue: '',
                remark: '',
                ruleId: '',
                rulesetId: '',
                state: 1,
            }, {
                compareType: '9',
                fieldCode: 'sbse',
                refObjectCode: 'sbse',
                refValue: '',
                refValue1: '',
                refValue2: '',
                remark: '',
                ruleId: '',
                rulesetId: '',
                state: 1,
            }, {
                compareType: '9',
                fieldCode: 'jxzc_se',
                refObjectCode: 'jxzc_se',
                refValue: '',
                refValue1: '',
                refValue2: '',
                remark: '',
                ruleId: '',
                rulesetId: '',
                state: 1,
            }, {
                compareType: '8',
                fieldCode: 'jxzc_lx',
                refObjectCode: 'jxzc_lx',
                refValue: '',
                remark: '',
                ruleId: '',
                rulesetId: '',
                state: 1,
            }, {
                compareType: '8',
                fieldCode: 'department_name',
                refObjectCode: 'department_name',
                refValue: '',
                remark: '',
                ruleId: '',
                rulesetId: '',
                state: 1,
            }, {
                compareType: '8',
                fieldCode: 'conf_id',
                refObjectCode: 'conf_id',
                refValue: '',
                remark: '',
                ruleId: '',
                rulesetId: '',
                state: 1,
            },
            ],
            stageList: [],
        }
        // 选择条件
        if (approveCode === 'red_info_approve') {
            $scope.taxpayerOptions3 = {
                data: [{
                    id: 'invoice_money',
                    text: '发票金额',
                }],
                placeholder: '添加条件字段',
                allowClear: true,
            }
        } else if (approveCode === 'sb_approve') {
            $scope.taxpayerOptions3 = {
                data: [{
                    id: 'zsxm_dm',
                    text: '税种',
                }, {
                    id: 'sbse',
                    text: '应纳税额',
                }],
                placeholder: '添加条件字段',
                allowClear: true,
            }
        } else if (approveCode === 'ivat_turnout_approve') {
            $scope.taxpayerOptions3 = {
                data: [{
                    id: 'jxzc_se',
                    text: '税额',
                }, {
                    id: 'jxzc_lx',
                    text: '转出类型',
                }],
                placeholder: '添加条件字段',
                allowClear: true,
            }
        } else if (approveCode === 'ivat_turnback_approve') {
            $scope.taxpayerOptions3 = {
                data: [{
                    id: 'jxzc_se',
                    text: '税额',
                }, {
                    id: 'jxzc_lx',
                    text: '转出类型',
                }],
                placeholder: '添加条件字段',
                allowClear: true,
            }
        } else if (approveCode === 'ivat_expense_approve') {
            $scope.taxpayerOptions3 = {
                data: [{
                    id: 'invoice_money',
                    text: '金额',
                }, {
                    id: 'department_name',
                    text: '部门',
                }, {
                    id: 'conf_id',
                    text: '报销类型',
                }],
                placeholder: '添加条件字段',
                allowClear: true,
            }
        } else {
            $scope.taxpayerOptions3 = {
                data: [{
                    id: 'invoice_type',
                    text: '发票类型',
                }, {
                    id: 'invoice_nature',
                    text: '发票性质',
                }, {
                    id: 'invoice_money',
                    text: '发票金额',
                }],
                placeholder: '添加条件字段',
                allowClear: true,
            }
        }
        $scope.jxzc_lx = []
        $scope.departmentName_lx = []
        $scope.confId_lx = []
        // 初始化变量
        let invoiceTypeArr = [] // 发票类型数组
        let invoiceNatureArr = [] // 发票性质
        let confId = ''
        let invoiceMoneyArr = []
        let informTypeArr = [] // 通知方式
        let sbzlDmArr = [] // 申报税种
        let jxzcLxArr = []
        let confIdArr = [] // 报销类型
        let departmetnNameArr = [] // 部门
        if (branchId) {
            // 获取数据
            httpRequest.get_qryApproveBranch({
                branchId,
            }).then((res) => {
                $scope.param = $.extend($scope.param, res.data.value)

                // 通知方式
                let noticeType = $scope.param.noticeType
                informTypeArr = noticeType.split(',')
                // 组装选中条件
                $scope.item3 = $scope.param.ruleSet.ruleList.map((item) => {
                    // 处理条件值命中
                    if (item.fieldCode == 'invoice_type') {
                        let invoiceType = item.refValue
                        invoiceTypeArr = invoiceType.split(',')
                        for (var a in $scope.invoiceType) {
                            if (invoiceTypeArr.indexOf(a) > -1) {
                                $scope.invoiceType[a] = true
                            }
                        }
                        $scope.param.ruleList[0] = $.extend($scope.param.ruleList[0], item)
                    }
                    if (item.fieldCode == 'invoice_nature') {
                        let invoiceNature = item.refValue
                        invoiceNatureArr = invoiceNature.split(',')
                        for (var a in $scope.invoiceNature) {
                            if (invoiceNatureArr.indexOf(a) > -1) {
                                $scope.invoiceNature[a] = true
                            }
                        }
                        $scope.param.ruleList[1] = $.extend($scope.param.ruleList[1], item)
                    }
                    if (item.fieldCode == 'zsxm_dm') {
                        let zsxmDm = item.refValue
                        sbzlDmArr = zsxmDm.split(',')
                        for (var a in $scope.zsxm_dm) {
                            if (sbzlDmArr.indexOf(a) > -1) {
                                $scope.zsxm_dm[a] = true
                            }
                        }
                        $scope.param.ruleList[3] = $.extend($scope.param.ruleList[3], item)
                    }
                    if (item.fieldCode == 'invoice_money') {
                        if (item.compareType == '9') {
                            let invoiceMoney = item.refValue
                            invoiceMoneyArr = invoiceMoney.split(',')
                            item.refValue1 = invoiceMoneyArr[0]
                            item.refValue2 = invoiceMoneyArr[1]
                        } else {
                            //
                            item.refValue1 = item.refValue
                        }

                        $scope.param.ruleList[2] = $.extend($scope.param.ruleList[2], item)
                    }
                    if (item.fieldCode == 'sbse') {
                        if (item.compareType == '9') {
                            let sbse = item.refValue
                            let sbseArr = sbse.split(',')
                            item.refValue1 = sbseArr[0]
                            item.refValue2 = sbseArr[1]
                        } else {
                            //
                            item.refValue1 = item.refValue
                        }

                        $scope.param.ruleList[4] = $.extend($scope.param.ruleList[4], item)
                    }
                    // if (item.fieldCode == 'jxzc_se') {
                    //     if (item.compareType == '9') {
                    //         let jxzcSe = item.refValue
                    //         let jxzcSeArr = jxzcSe.split(',')
                    //         item.refValue1 = jxzcSeArr[0]
                    //         item.refValue2 = jxzcSeArr[1]
                    //     } else {
                    //         //
                    //         item.refValue1 = item.refValue
                    //     }

                    //     $scope.param.ruleList[5] = $.extend($scope.param.ruleList[5], item)
                    // }
                    // if (item.fieldCode == 'jxzc_lx') {
                    //     // $scope.jxzc_lx[0] = true
                    //     let jxzcLx = item.refValue
                    //     jxzcLxArr = jxzcLx.split(',')
                    //     // // 转出类型
                    //     httpRequest.get_qryTurnoutCategoryAll().then((res) => {
                    //         $scope.turnCategory = res.data.value
                    //         for (let a = 0, l = $scope.turnCategory.length; a < l; a++) {
                    //             if (jxzcLxArr.indexOf($scope.turnCategory[a].categoryId) > -1) {
                    //                 $scope.jxzc_lx[a] = true
                    //             }
                    //         }

                    //         $scope.param.ruleList[6] = $.extend($scope.param.ruleList[6], item)
                    //     })
                    // }
                    if (item.fieldCode == 'department_name') {
                        let departmetnName = item.refValue
                        departmetnNameArr = departmetnName.split(',')
                        // 部门列表
                        httpRequest.get_getDeparmentOfOrg(true).then((res) => {
                            $scope.reimburseDepartment = res.data.value
                            for (let a = 0, l = $scope.reimburseDepartment.length; a < l; a++) {
                                if (departmetnNameArr.indexOf($scope.reimburseDepartment[a].departmentName) > -1) {
                                    $scope.departmentName_lx[a] = true
                                }
                            }
                            $scope.param.ruleList[7] = $.extend($scope.param.ruleList[7], item)
                        })
                    }
                    if (item.fieldCode == 'conf_id') {
                        confId = item.refValue
                        confIdArr = confId.split(',')
                        // 报销类型
                        httpRequest.get_getIvatBxPzDTOList(true).then((res) => {
                            $scope.reimburseConfid = res.data.value
                            for (let a = 0, l = $scope.reimburseConfid.length; a < l; a++) {
                                if (confIdArr.indexOf($scope.reimburseConfid[a].confId) > -1) {
                                    $scope.confId_lx[a] = true
                                }
                            }
                            $scope.param.ruleList[8] = $.extend($scope.param.ruleList[8], item)
                        })
                    }
                    return item.fieldCode
                })
                $scope.s3item = $scope.taxpayerOptions3.data.filter((item) => {
                    if ($scope.item3.indexOf(item.id) > -1) {
                        return item
                    }
                })
                // 通知方式命中
                for (const a in $scope.informType) {
                    if (informTypeArr.indexOf(a) > -1) {
                        $scope.informType[a] = true
                    }
                }
            })
        }
        //获取报销类型
        httpRequest.get_getIvatBxPzDTOList(true).then((res) => {
            $scope.reimburseConfid = res.data.value
        })
        // 部门列表
        httpRequest.get_getDeparmentOfOrg(true).then((res) => {
            $scope.reimburseDepartment = res.data.value
        })
        // 转出类型
        // httpRequest.get_qryTurnoutCategoryAll().then((res) => {
        //     $scope.turnCategory = res.data.value
        //     // $scope.turnCategory.unshift({categoryId:'',category:'全部'})
        // })

        // 条件显隐
        $scope.showCondition = function (v, obj) {
            let flag = false
            for (const a in obj) {
                if (obj[a].id === v) {
                    flag = true
                }
            }
            return flag
        }
        // 作废不需要电子票
        $scope.invoiceType = approveCode == 'cancel_invoice_approve' || approveCode == 'reopen_invoice_approve' ? {
            0: false,
            2: false,
            12: false,
            41: false,
        } : {
                0: false,
                2: false,
                51: false,
                12: false,
                41: false,
            }
        $scope.invoiceTypeChange = function (v, n) {
            if (v) {
                invoiceTypeArr.push(n)
            } else {
                invoiceTypeArr.splice(invoiceTypeArr.indexOf(n), 1)
            }
            $scope.param.ruleList[0].refValue = invoiceTypeArr.join(',')
        }
        // 申报税种
        $scope.zsxm_dm = {
            10101: false,
        }
        $scope.sbzlDmChange = function (v, n) {
            if (v) {
                sbzlDmArr.push(n)
            } else {
                sbzlDmArr.splice(sbzlDmArr.indexOf(n), 1)
            }
            $scope.param.ruleList[3].refValue = sbzlDmArr.join(',')
        }
        // 发票性质
        $scope.invoiceNature = {
            0: false,
            1: false,
        }
        $scope.invoiceNatureChange = function (v, n) {
            if (v) {
                invoiceNatureArr.push(n)
            } else {
                invoiceNatureArr.splice(invoiceNatureArr.indexOf(n), 1)
            }
            $scope.param.ruleList[1].refValue = invoiceNatureArr.join(',')
        }

        // 通知方式
        $scope.informType = {
            email: false,
            message: false,
        }
        $scope.informTypeChange = function (v, n) {
            // 看数据结构决定
            if (v) {
                informTypeArr.push(n)
            } else {
                informTypeArr.splice(informTypeArr.indexOf(n), 1)
            }
            $scope.param.noticeType = informTypeArr.join(',')
        }

        $scope.departmentNameChange = function (v, n) {
            if (v) {
                departmetnNameArr.push($scope.reimburseDepartment[n].departmentName)
            } else {
                departmetnNameArr.splice(departmetnNameArr.indexOf($scope.reimburseDepartment[n].departmentName), 1)
            }
            $scope.param.ruleList[7].refValue = departmetnNameArr.join(',')
        }

        $scope.confidChange = function (v, n) {
            if (v) {
                confIdArr.push($scope.reimburseConfid[n].confId)
            } else {
                confIdArr.splice(confIdArr.indexOf($scope.reimburseConfid[n].confId), 1)
            }
            $scope.param.ruleList[8].refValue = confIdArr.join(',')
        }

        // 选择通知人员
        $scope.choosePerson = function (index) {
            if ($scope.param.stageList.length >= 5 && index == -1) {
                logger.logError('审批人最多支持5级审批')
                return
            }
            // 弹窗
            const choosePersonModalData = {
                arr: $scope.param.stageList,
                index,
            } // 可以重复选择，忽略此参数
            const modalInstance = $uibModal.open({
                template: choosePersonPage,
                controller: 'chooseCheckPersonCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal-chooseperson mod-modal mod-modal-lg',
                resolve: {
                    items1 () {
                        return choosePersonModalData
                    },
                },
            })
            modalInstance.result.then((item) => {
                const _order = $scope.param.stageList.length
                const newChosenPeople = {
                    approveType: item.choosetype,
                    approverList: [],
                    stageName: item.title,
                    stageOrder: _order,
                    wfApproverList: item.selectedList,
                }
                newChosenPeople.approverList = toApproverData(item.selectedList, 'uniqueUserId', 'userName')
                newChosenPeople.approvers = getApprovers(item.selectedList, 'userName')
                if (index != -1) {
                    $scope.param.stageList[index] = newChosenPeople
                } else {
                    $scope.param.stageList.push(newChosenPeople)
                }
            })
        }

        function getApprovers (list, textfield) {
            const result = []
            for (const a in list) {
                result.push(list[a][textfield])
            }
            return result.join('\\')
        }
        // 转换选中人员字段
        function toApproverData (list, idfield, textfield) {
            const result = []
            for (const a in list) {
                const tempdata = {
                    // approverId : "",
                    appoverName: '',
                }
                // $.extend(tempdata,list[a]);
                // tempdata.approverId = list[a][idfield];
                tempdata.appoverName = list[a][textfield]
                result.push(tempdata)
            }
            return result
        }

        $scope.submit = function () {
            // 限制条件
            // 限制条件
            // var opening  = layer.msg('提交中，请耐心等待', {time: 0, skin: 'layer-loading-self', icon: 16, shade: 0.5});
            if ($scope.param.stageList.length == 0) {
                logger.logError('审批人不能为空')
                return
            }
            if ($scope.s3item === undefined || $scope.s3item.length === 0) {
                logger.logError('请至少设置一个有效判断条件')
                return
            }
            $scope.item3 = $scope.s3item.map((item) => item.id)
            if ($scope.item3.indexOf('invoice_type') > -1 && $scope.param.ruleList[0].refValue === '') {
                logger.logError('请至少选择一种发票类型')
                return
            }
            if ($scope.item3.indexOf('invoice_nature') > -1 && $scope.param.ruleList[1].refValue === '') {
                logger.logError('请至少选择一种发票性质')
                return
            }
            if ($scope.item3.indexOf('zsxm_dm') > -1 && $scope.param.ruleList[3].refValue === '') {
                logger.logError('请至少选择一种税种')
                return
            }
            if ($scope.item3.indexOf('jxzc_lx') > -1 && $scope.param.ruleList[6].refValue === '') {
                logger.logError('请至少选择一种转出类型')
                return
            }
            if ($scope.item3.indexOf('department_name') > -1 && $scope.param.ruleList[7].refValue === '') {
                logger.logError('请至少选择一个部门')
                return
            }
            if ($scope.item3.indexOf('conf_id') > -1 && $scope.param.ruleList[8].refValue === '') {
                logger.logError('请至少选择一种报销类型')
                return
            }
            if ($scope.item3.indexOf('invoice_money') > -1) {
                if ($scope.param.ruleList[2].compareType == '9') {
                    if (!isPnumReg.test($scope.param.ruleList[2].refValue1) || !isPnumReg.test($scope.param.ruleList[2].refValue2)) {
                        logger.logError('发票金额为15位以内的正整数')
                        return
                    }
                    if (Number($scope.param.ruleList[2].refValue1) >= Number($scope.param.ruleList[2].refValue2)) {
                        logger.logError('发票金额第一个值需小于第二个值')
                        return
                    }
                    $scope.param.ruleList[2].refValue = `${$scope.param.ruleList[2].refValue1},${$scope.param.ruleList[2].refValue2}`
                } else {
                    if (!isPnumReg.test($scope.param.ruleList[2].refValue1)) {
                        logger.logError('发票金额为15位以内的正整数')
                        return
                    }
                    $scope.param.ruleList[2].refValue = $scope.param.ruleList[2].refValue1
                }
            }
            if ($scope.item3.indexOf('sbse') > -1) {
                if ($scope.param.ruleList[4].compareType == '9') {
                    if (!isPnumReg.test($scope.param.ruleList[4].refValue1) || !isPnumReg.test($scope.param.ruleList[4].refValue2)) {
                        logger.logError('应纳税额为15位以内的正整数')
                        return
                    }
                    if (Number($scope.param.ruleList[4].refValue1) >= Number($scope.param.ruleList[4].refValue2)) {
                        logger.logError('应纳税额第一个值需小于第二个值')
                        return
                    }
                    $scope.param.ruleList[4].refValue = `${$scope.param.ruleList[4].refValue1},${$scope.param.ruleList[4].refValue2}`
                } else {
                    if (!isPnumReg.test($scope.param.ruleList[4].refValue1)) {
                        logger.logError('应纳税额为15位以内的正整数')
                        return
                    }
                    $scope.param.ruleList[4].refValue = $scope.param.ruleList[4].refValue1
                }
            }
            if ($scope.item3.indexOf('jxzc_se') > -1) {
                if ($scope.param.ruleList[5].compareType == '9') {
                    if (!isPnumReg.test($scope.param.ruleList[5].refValue1) || !isPnumReg.test($scope.param.ruleList[5].refValue2)) {
                        logger.logError('税额为15位以内的正整数')
                        return
                    }
                    if (Number($scope.param.ruleList[5].refValue1) >= Number($scope.param.ruleList[5].refValue2)) {
                        logger.logError('税额第一个值需小于第二个值')
                        return
                    }
                    $scope.param.ruleList[5].refValue = `${$scope.param.ruleList[5].refValue1},${$scope.param.ruleList[5].refValue2}`
                } else {
                    if (!isPnumReg.test($scope.param.ruleList[5].refValue1)) {
                        logger.logError('税额为15位以内的正整数')
                        return
                    }
                    $scope.param.ruleList[5].refValue = $scope.param.ruleList[5].refValue1
                }
            }
            const newRuleList = []
            for (let i = 0, l = $scope.param.ruleList.length; i < l; i++) {
                if ($scope.item3.indexOf($scope.param.ruleList[i].fieldCode) > -1) {
                    newRuleList.push($scope.param.ruleList[i])
                }
            }
            $scope.param.ruleList = newRuleList
            if (branchId) {
                httpRequest.post_modApproveBranch($scope.param).then((res) => {
                    if (res.data.success) {
                        logger.logSuccess('修改成功')
                        $location.path(`/system/settingcenter/checkStreams/setting/${approveCode}`).replace()
                    }
                })
            } else {
                try {
                    $scope.isOnSubmit = true // 完成按钮设置为禁用
                    httpRequest.post_addApproveBranch($scope.param).then((res) => {
                        if (res.data.success) {
                            logger.logSuccess('添加成功')
                            $location.path(`/system/settingcenter/checkStreams/setting/${approveCode}`).replace()
                        }
                        $scope.isOnSubmit = false
                    })
                } catch (e) {
                    $scope.isOnSubmit = false // 获取任何异常完成按钮恢复可用状态
                }
            }
        }


        $scope.cancel = function () {
            $location.path(`/system/settingcenter/checkStreams/setting/${approveCode}`).replace()
            return false
        }
        $scope.turnoutCategoryChange = function turnoutCategoryChange (v, n) {
            if (v) {
                jxzcLxArr.push($scope.turnCategory[n].categoryId)
            } else {
                jxzcLxArr.splice(jxzcLxArr.indexOf($scope.turnCategory[n].categoryId), 1)
            }
            $scope.param.ruleList[6].refValue = jxzcLxArr.join(',')
        }
        // 删除通知人员
        $scope.delInformPerson = function ($index) {
            $scope.param.stageList.splice($index, 1)
        }
    }
}

checkStreamsBranchEditCtrl.$inject = ['$scope', '$uibModal', '$location', 'logger', 'httpRequest', '$state']
export default checkStreamsBranchEditCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/checkStreams/checkStreamsBranchEditCtrl.js